import { httpPost } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSelectSubscriptionPlan = async ({
  planGroupId,
  planId,
  customerId,
  lang,
}: {
  planGroupId: string;
  planId: string;
  customerId: string;
  lang: string;
}) => {
  return formatPaymentResponse(
    await httpPost<PaymentApiResponse>(
      `subscriptions/embeds/${planGroupId}/?customer=${customerId}&plan=${planId}&lang=${lang}`
    )
  );
};
